<div [formGroup]="parentForm" class="light-type" [class.ps-small-t]="displayContainerStyles">
  <label class="checkbox-container flex" [for]="idOrControlName">
    <input
      #inputElement
      type="checkbox"
      [attr.name]="translationPrefix + '.label' | finLocalization"
      [attr.aria-required]="isRequired"
      [value]="checkboxValue"
      [id]="idOrControlName"
      [formControlName]="controlName"
      [name]="controlName"
      class="is-vishidden"
    />
    <span class="checkbox-icon nordic-blue-900-text text-icon-primary" aria-hidden="true">
      @switch (control.value) {
        @case (true) {
          <fcom-icon class="icon-small" [name]="SvgLibraryIcon.CHECKBOX_SELECTED" />
        }
        @default {
          <fcom-icon class="icon-small" [name]="SvgLibraryIcon.CHECKBOX_UNSELECTED" />
        }
      }
    </span>
    @if (!descriptionText) {
      <span [ngClass]="labelClass">
        {{ translationPrefix + '.label' | finLocalization }}
        @if (isRequired) {
          <span> *</span>
        }
      </span>
    }

    @if (descriptionText) {
      <span class="label font-body-1 ps-xsmall-l font-body-medium">
        <div class="medium-type">
          {{ translationPrefix + '.label' | finLocalization }}
          @if (isRequired) {
            <span> *</span>
          }
        </div>
        <div class="font-body-2 nordic-blue-900-text text-icon-primary font-body-small">{{ descriptionText }}</div>
      </span>
    }
  </label>

  @if (ctrlField.invalid && ctrlField.touched) {
    <div class="error-label font-body-2 regular-type font-body-small" aria-live="polite">
      @if (ctrlField.errors?.required) {
        <span class="error-900-text signal-error-notification-border-icon-text">
          {{ translationPrefix + '.required' | finLocalization }}
        </span>
      }
    </div>
  }
</div>
